export default __webpack_public_path__ + "images/2ff3bca98997b0e6541451e7abb4098f.svg";